import get from "lodash/get";
import sortBy from "lodash/sortBy";
import { SortProperties, useTableSort } from "./useTableSort";

export const useTableSortWithData = <T>({
  data,
  defaultSort,
  enabled = true,
  getSortValue,
  saveKey,
}: {
  data: T[];
  defaultSort?: SortProperties;
  enabled?: boolean;
  getSortValue?: (row: T, sortField: string) => unknown;
  saveKey?: string;
}) => {
  const sort = useTableSort(defaultSort, saveKey);

  if (!enabled || !data || data.length === 0) {
    return {
      ...sort,
      data,
    };
  }

  const sortData = () => {
    if (!sort?.sortField) return data;

    const sortedData = sortBy(data, (dataItem) => {
      const value = getSortValue
        ? getSortValue(dataItem, sort.sortField!)
        : get(dataItem, sort.sortField!);
      const numericValue = Number(value);
      const isNaN = Number.isNaN(numericValue);
      const normalized = isNaN
        ? typeof value === "string"
          ? value.toLowerCase()
          : value
        : numericValue;
      // "" is to treat null values as empty strings to sort correctly. works with numbers and booleans too
      return normalized || "";
    });

    if (sort?.sortDirection === "DESC") {
      return sortedData.reverse();
    }

    return sortedData;
  };

  return {
    ...sort,
    data: sortData(),
  };
};
